import { useEffect, useRef, useState } from "react";
import { wsUrl } from "@/lib/api";

export function useFleetSocket(onMessage) {
  const [connected, setConnected] = useState(false);
  const handlerRef = useRef(onMessage);
  handlerRef.current = onMessage;

  useEffect(() => {
    let socket;
    let retry;
    let closed = false;

    const open = () => {
      const token = localStorage.getItem("doot_access");
      if (!token) return;
      socket = new WebSocket(wsUrl(token));
      socket.onopen = () => setConnected(true);
      socket.onmessage = (evt) => {
        try {
          handlerRef.current?.(JSON.parse(evt.data));
        } catch (e) {
          /* ignore malformed frame */
        }
      };
      socket.onclose = () => {
        setConnected(false);
        if (!closed) retry = setTimeout(open, 3000);
      };
      socket.onerror = () => socket.close();
    };
    open();

    return () => {
      closed = true;
      clearTimeout(retry);
      socket?.close();
    };
  }, []);

  return connected;
}
